export const DEFAULT_ASKWITTY_NODE_PROXY_PATH = "/__pw_node";

const SAME_ORIGIN_ASKWITTY_HOSTS = new Set([
  "localhost",
  "127.0.0.1",
  "[::1]",
  "dev.partywitty.com",
  "www.dev.partywitty.com",
]);

export function normalizeAskWittyProxyPath(
  rawPath,
  fallback = DEFAULT_ASKWITTY_NODE_PROXY_PATH,
) {
  const value = String(rawPath || "").trim();
  if (
    !value
    || !value.startsWith("/")
    || value.startsWith("//")
    || value.includes("?")
    || value.includes("#")
  ) {
    return fallback;
  }
  const normalized = `/${value.replace(/^\/+/, "").replace(/\/+$/, "")}`;
  return normalized === "/" ? fallback : normalized;
}

export function resolveAskWittyNodeBaseUrl({
  hostname,
  nodeApiBaseUrl,
  proxyPath,
} = {}) {
  const normalizedHostname = String(hostname || "").trim().toLowerCase();
  if (SAME_ORIGIN_ASKWITTY_HOSTS.has(normalizedHostname)) {
    return normalizeAskWittyProxyPath(proxyPath);
  }
  return String(nodeApiBaseUrl || "").trim().replace(/\/+$/, "");
}

export function joinAskWittyNodePath(baseUrl, endpoint) {
  const base = String(baseUrl || "").replace(/\/+$/, "");
  const path = `/${String(endpoint || "").replace(/^\/+/, "")}`;
  return `${base}${path}`;
}
